import React from 'react';
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';

const Payments = () => {
    const androidLink = 'https://play.google.com/store/apps/details?id=com.romwalletappfront&pli=1'; // Android 앱 링크
    const iosLink = 'https://apps.apple.com/us/app/%EB%A1%AC%EC%9B%94%EB%A0%9B/id6560115402'; // iOS 앱 링크
  
    return (
        <div id="rompayment">

            <div className='container'>
                <img src={require('../img/rom/text-logo1.png')}/>
                <div className='pattern-box'>
                    <div className='approval-box'>
                        ROM WALLET이 설치되어 있지 않습니다. <br/>
                        아래 버튼을 터치하여 앱을 설치해주세요.
                        <div style={{
                            marginTop: '30px',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%'
                        }}>
                            <a href={androidLink} target="_blank" rel="noopener noreferrer">
                                <button
                                    style={{
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        marginRight: '10px',
                                        backgroundColor: '#3DDC84',
                                        color: 'black',
                                        border: 'none',
                                        borderRadius: '50px',
                                        cursor: 'pointer',
                                        width: '100%'
                                    }}
                                >
                                    <AndroidOutlined/> 안드로이드
                                </button>
                            </a>

                            {/* iPhone 다운로드 버튼 */}
                            <a href={iosLink} target="_blank" rel="noopener noreferrer">
                                <button
                                    style={{
                                        padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007AFF',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50px',
                                        cursor: 'pointer',
                                        width: '100%',
                                        marginTop: '10px'
                                    }}
                                >
                                    <AppleOutlined/> 아이폰
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Payments;